import { RouterGateway } from '../routing/router.gateway'
import { HttpGateway } from '../services/http.gateway'
import { SessionStorageGateway } from '../services/session-storage.gateway'
import { LocalStorageGateway } from '../services/local-storage.gateway'
import { WindowGateway } from '../services/window.gateway'
import { ViewportGateway } from '../services/viewport.gateway'
import { DocumentGateway } from '../services/document.gateway'
import { ServiceWorkerGateway } from '../services/service-worker.gateway'
import { ClockGateway } from '../services/clock.gateway'
import { IdGeneratorGateway } from '../services/id-generator.gateway'
import { RandomGateway } from '../services/random.gateway'
import { LoggingGateway } from '../services/logging.gateway'
import { TelemetryGateway } from '../services/telemetry.gateway'
import { ConnectivityGateway } from '../services/connectivity.gateway'
import { FormatGateway } from '../services/format.gateway'
import { Types } from './types'
import { BaseIOC } from './container.base'

export const container = new BaseIOC().buildBaseTemplate()

container.bind(Types.IDataGateway).to(HttpGateway).inSingletonScope()
container.bind(Types.IRouterGateway).to(RouterGateway).inSingletonScope()
container.bind(Types.ISessionStorageGateway).to(SessionStorageGateway).inSingletonScope()
container.bind(Types.ILocalStorageGateway).to(LocalStorageGateway).inSingletonScope()
container.bind(Types.IWindowGateway).to(WindowGateway).inSingletonScope()
container.bind(Types.IViewportGateway).to(ViewportGateway).inSingletonScope()
container.bind(Types.IDocumentGateway).to(DocumentGateway).inSingletonScope()
container.bind(Types.IServiceWorkerGateway).to(ServiceWorkerGateway).inSingletonScope()
container.bind(Types.IClockGateway).to(ClockGateway).inSingletonScope()
container.bind(Types.IIdGeneratorGateway).to(IdGeneratorGateway).inSingletonScope()
container.bind(Types.IRandomGateway).to(RandomGateway).inSingletonScope()
container.bind(Types.ILoggingGateway).to(LoggingGateway).inSingletonScope()
container.bind(Types.ITelemetryGateway).to(TelemetryGateway).inSingletonScope()
container.bind(Types.IConnectivityGateway).to(ConnectivityGateway).inSingletonScope()
container.bind(Types.IFormatGateway).to(FormatGateway).inSingletonScope()
